import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import { colorArray } from '../../../../constants/constants';

export interface Highlight {
  term: string;
  color: string;
}

const HighlightPanel = () => {
  const highlightToggleOn = useSelector(
    (state: RootState) => state.ecaHighLightText.toggleOnHighlight
  );
  const highLightedWordsData = useSelector(
    (state: RootState) => state.ecaDocumentViewer.highLightedWords
  );
  const highlights = useSelector(
    (state: RootState) => state.ecaHighLightText.highlights
  );

  const strSearchFlag = useSelector(
    (state: RootState) => state.ecaDocumentViewer.strSearchFlag
  );

  // const colors = ['#FF9E2C', '#B290E5', '#55D5A7', '#89A6FF']

  const colors = ['#55D5A7']

  const colorsMapping = () => {
    if (!Array.isArray(highLightedWordsData)) return {};

    return highLightedWordsData.reduce(
      (acc, label, index) => {
        acc[label] = colors[index % colors.length];

        return acc;
      },
      {} as Record<string, string>
    );
  };

  const colorMap = colorsMapping()


  return (
    <div className="p-4 border-l border-gray-300 w-1/4 bg-gray-100">
      <div>
        {strSearchFlag && highlights?.map(({ term, color }) => (
          <div
            key={term}
            className={
              highlightToggleOn ? 'show-highlights  ' : 'hide-highlights'
            }
          >
            {highlightToggleOn && (
              
              <>
                <span
                  className="typo-text body3_size panel-highlighted-word "
                  style={{
                    backgroundColor: color,
                    color: colorArray.find(x => x.backgroundColor === color)?.textColor || '#000000'
                  }}
                >
                  {term}
                </span>
              </>)}
          </div>
        ))}
        {!strSearchFlag && highLightedWordsData?.map((word) => (
          <div
            key={word}
            className={
              highlightToggleOn && (highLightedWordsData.length !== 0) ? 'show-highlights  ' : 'hide-highlights'
            }
          >
            {highlightToggleOn && (
              <>
                <span
                  className="typo-text body3_size panel-highlighted-word "
                  style={{
                    backgroundColor: colorMap[word],
                  }}
                >
                  {word}
                </span>
              </>)}
          </div>
        ))}
      </div>

      {!highlightToggleOn && (
        <div className="no-highlights">
          <Typography className="typo-text body2_size no-highlights-text">
            {t(`eca.documentPreviewer.highlightsPanel.noHighlights`)}
          </Typography>
        </div>
      )}
    </div>
  );
};
export default HighlightPanel;